'use strict';

// Explicit require so esbuild sees the dependency edge and guarantees dollar-slice
// initializes before this module body runs. Previously relied on window.DS being
// set by aaa-module-mounting loading first — a fragile implicit ordering that broke
// when bundled by esbuild (see global/js/client.js FIXME comment).
const DS = require('dollar-slice');

/**
 * Generates a unique id on the _client_.
 *
 * @example $cid();
 */
DS.service('$cid', function () {

  var counter = Math.floor(Math.random() * 100); // random number between 0 and 100

  return function () {
    counter++; // iterate
    return 'cid-' + counter;
  };
});
